import { AppSettings } from '../configs';
import { authHeader } from '../helpers/auth-header';
import axios  from "../utils/axios";

const SettingSessionTimeoutService = {

    getItems: (transaction_no) => {
        return new Promise((resolve, reject) => {
            axios({
              headers: {...authHeader(),'Pragma': 'no-cache'},
              method: "get",
              url: `${AppSettings.apiUrl}/api/SettingSessionTimeout/GetSessionTimeout`,
              data: {}
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error))
          })
      },
      UpdateSessionTimeout: (data) => {
        return new Promise((resolve, reject) => {
            axios({
              headers: {...authHeader(),'Pragma': 'no-cache'},
              method: "post",
              url: `${AppSettings.apiUrl}/api/SettingSessionTimeout/UpdateSessionTimeout`,
              data: data
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error))
          })
      },
};


export default SettingSessionTimeoutService;